export var getFormFieldState = function getFormFieldState(_ref) {
  var disabled = _ref.disabled,
    error = _ref.error;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (disabled) return 'disabled';
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (error) return 'error';
  return 'normal';
};